import { useEffect } from 'react';

let sessionValidationFunction = null;

export const validateSession = async () => {
  if (sessionValidationFunction) {
    return await sessionValidationFunction();
  }
  return true;
};

export const useConcurrentLoginPrevention = (userData) => {
  useEffect(() => {
    const sessionId = sessionStorage.getItem('SessionId');
    if (!sessionId || !userData?.UserId) return;

    sessionValidationFunction = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_USER_API}/validate-session`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'x-session-id': sessionId
          },
          body: JSON.stringify({ userId: userData.UserId, sessionId })
        });
        
        if (!response.ok) {
          sessionStorage.clear();
          window.location.reload();
          return false;
        }
        return true;
      } catch (error) {
        console.error('Session validation error:', error);
        return false;
      }
    };

    return () => {
      sessionValidationFunction = null;
    };
  }, [userData]);
};
